
export enum IToasterVariant {
    Success = "success",
    Info = "information",
    Warning = "warning",
    Error = "error"
}

export interface IToasterInput {
    toasterVariant: IToasterVariant,
    toasterTimeoutMs: number,
    toasterHeader:string
    toasterMessage:string
}
